import {Archive} from '../../admin/publications/types/Archive';
import {PublicationItemsCacheService} from '../../common/services/publicationItemsCacheService';

class ArchivesCacheService extends PublicationItemsCacheService<Archive> {
  constructor() {
    super('/archives', 'Error fetching archives for publication:');
  }

  public async getArchivesForPublication(publicationId: string): Promise<Archive[]> {
    return this.getItemsForPublication(publicationId);
  }

  public getArchiveNameByAbbreviation(publicationId: string, abbreviation: string): string | undefined {
    const archive = this.getItemByAbbreviation(publicationId, abbreviation);
    return archive?.name;
  }
}

export default new ArchivesCacheService();

